// 비밀번호 재설정 페이지 JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // 비밀번호 재설정 페이지가 아니면 실행하지 않음
  const userIdInput = document.getElementById('userId');
  if (!userIdInput) {
    return; // 해당 페이지가 아니면 종료
  }
  
  // sessionStorage에서 userId 가져오기
  const resetUserId = sessionStorage.getItem('resetUserId');
  
  if (resetUserId) {
    userIdInput.value = resetUserId;
    // 사용 후 삭제
    sessionStorage.removeItem('resetUserId');
  } else {
    // userId가 없으면 비밀번호 찾기 페이지로 리다이렉트
    alert('잘못된 접근입니다.');
    window.location.href = 'auth-find-password.html';
    return;
  }
  
  const newPasswordInput = document.getElementById('newPassword');
  const confirmPasswordInput = document.getElementById('confirmPassword');
  const form = document.getElementById('resetPasswordForm');
  
  // 비밀번호 강도 체크
  newPasswordInput.addEventListener('input', function() {
    checkPasswordStrength(this.value);
    checkPasswordMatch();
  });
  
  // 비밀번호 확인 체크
  confirmPasswordInput.addEventListener('input', function() {
    checkPasswordMatch();
  });
  
  // 폼 제출 처리
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    
    const newPassword = newPasswordInput.value;
    const confirmPassword = confirmPasswordInput.value;
    
    // 비밀번호 검증
    if (!validatePassword(newPassword)) {
      alert('비밀번호가 규칙에 맞지 않습니다.\n규칙을 확인해주세요.');
      return;
    }
    
    if (newPassword !== confirmPassword) {
      alert('비밀번호가 일치하지 않습니다.');
      return;
    }
    
    // 비밀번호 변경 시뮬레이션
    changePassword(newPassword);
  });
});

// 비밀번호 강도 체크
function checkPasswordStrength(password) {
  const strengthFill = document.getElementById('strengthFill');
  const strengthText = document.getElementById('strengthText');
  
  let score = 0;
  let feedback = '';
  
  // 길이 체크
  if (password.length >= 8) score += 1;
  
  // 대소문자 체크
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score += 1;
  
  // 숫자 체크
  if (/\d/.test(password)) score += 1;
  
  // 특수문자 체크
  if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) score += 1;
  
  // 강도에 따른 색상 및 텍스트 변경
  switch (score) {
    case 0:
    case 1:
      strengthFill.style.width = '25%';
      strengthFill.style.background = '#f44336';
      feedback = '매우 약함';
      break;
    case 2:
      strengthFill.style.width = '50%';
      strengthFill.style.background = '#ff9800';
      feedback = '약함';
      break;
    case 3:
      strengthFill.style.width = '75%';
      strengthFill.style.background = '#2196f3';
      feedback = '보통';
      break;
    case 4:
      strengthFill.style.width = '100%';
      strengthFill.style.background = '#4caf50';
      feedback = '강함';
      break;
  }
  
  strengthText.textContent = feedback;
  
  // 규칙 체크 표시
  updatePasswordRules(password);
  
  return score >= 3;
}

// 비밀번호 규칙 표시 업데이트
function updatePasswordRules(password) {
  const rules = {
    'rule-length': password.length >= 8 && password.length <= 16,
    'rule-letter': /[a-z]/.test(password) && /[A-Z]/.test(password),
    'rule-number': /\d/.test(password),
    'rule-special': /[!@#$%^&*(),.?":{}|<>]/.test(password)
  };
  
  Object.keys(rules).forEach(ruleId => {
    const element = document.getElementById(ruleId);
    if (rules[ruleId]) {
      element.classList.add('valid');
      element.classList.remove('invalid');
      element.textContent = '✓ ' + element.textContent.replace(/^[✓✗] /, '');
    } else {
      element.classList.add('invalid');
      element.classList.remove('valid');
      element.textContent = '✗ ' + element.textContent.replace(/^[✓✗] /, '');
    }
  });
}

// 비밀번호 일치 확인
function checkPasswordMatch() {
  const newPassword = document.getElementById('newPassword').value;
  const confirmPassword = document.getElementById('confirmPassword').value;
  const matchDiv = document.getElementById('passwordMatch');
  
  if (confirmPassword === '') {
    matchDiv.textContent = '';
    matchDiv.className = 'password-match';
    return;
  }
  
  if (newPassword === confirmPassword) {
    matchDiv.textContent = '✓ 비밀번호가 일치합니다';
    matchDiv.className = 'password-match valid';
  } else {
    matchDiv.textContent = '✗ 비밀번호가 일치하지 않습니다';
    matchDiv.className = 'password-match invalid';
  }
}

// 비밀번호 유효성 검사
function validatePassword(password) {
  const minLength = 8;
  const maxLength = 16;
  const hasLowerCase = /[a-z]/.test(password);
  const hasUpperCase = /[A-Z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  
  return password.length >= minLength && 
         password.length <= maxLength &&
         hasLowerCase && 
         hasUpperCase && 
         hasNumbers && 
         hasSpecialChar;
}

// 비밀번호 변경 시뮬레이션
function changePassword(newPassword) {
  const submitBtn = document.querySelector('.btn-primary');
  const originalText = submitBtn.textContent;
  
  submitBtn.textContent = '변경 중...';
  submitBtn.disabled = true;
  
  setTimeout(() => {
    submitBtn.textContent = originalText;
    submitBtn.disabled = false;
    
    // 성공 페이지 표시
    showPasswordChangeSuccess();
  }, 2000);
}

// 비밀번호 변경 성공 표시
function showPasswordChangeSuccess() {
  const form = document.getElementById('resetPasswordForm');
  const successArea = document.getElementById('successArea');
  
  // 폼 숨기고 성공 메시지 표시
  form.style.display = 'none';
  successArea.style.display = 'block';
  
  // 5초 후 자동으로 로그인 페이지로 이동
  setTimeout(() => {
    window.location.href = '/auth/login';
  }, 3000);
}

// 비밀번호 표시/숨김 토글 기능
function togglePasswordVisibility(inputId) {
  const input = document.getElementById(inputId);
  const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
  input.setAttribute('type', type);
}

// Enter 키 처리
document.addEventListener('keydown', function(e) {
  if (e.key === 'Enter') {
    const activeElement = document.activeElement;
    if (activeElement.id === 'newPassword') {
      document.getElementById('confirmPassword').focus();
    } else if (activeElement.id === 'confirmPassword') {
      document.getElementById('resetPasswordForm').dispatchEvent(new Event('submit'));
    }
  }
});
